import { login, logout } from 'src/client'

export const ROUTE_NAMES = {
  LOGIN: 'login',
  LOGOUT: 'logout'
}

const ROUTES = {
  [ROUTE_NAMES.LOGIN]: {
    name: ROUTE_NAMES.LOGIN,
    path: '/login'
  },
  [ROUTE_NAMES.LOGOUT]: {
    name: ROUTE_NAMES.LOGOUT,
    path: '/logout'
  }
}

export default [
  {
    name: ROUTES[ROUTE_NAMES.LOGIN].name,
    path: ROUTES[ROUTE_NAMES.LOGIN].path,
    component: () => login(),
    meta: { skipIfAuthenticated: true }
  },
  {
    name: ROUTES[ROUTE_NAMES.LOGOUT].name,
    path: ROUTES[ROUTE_NAMES.LOGOUT].path,
    component: () => logout()
  }
]
